<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconSpotlight_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M1 3v3h2V3h3V1H3q-.824 0-1.412.587A1.93 1.93 0 0 0 1 3M3 23h3v-2H3v-3H1v3q0 .824.587 1.413Q2.176 23 3 23M18 21v2h3q.824 0 1.413-.587Q23 21.825 23 21v-3h-2v3zM21 3v3h2V3q0-.824-.587-1.412A1.93 1.93 0 0 0 21 1h-3v2zM12 12.423c1.76 0 3.19-1.44 3.19-3.212C15.19 7.441 13.757 6 12 6S8.81 7.44 8.81 9.211c0 1.772 1.43 3.212 3.19 3.212M17.213 15.338c-.83-.894-2.396-1.558-5.213-1.558-2.84 0-4.409.676-5.233 1.581l-.022.024c-.223.244-.584.639-.735 1.612A.873.873 0 0 0 6.868 18h10.264c.528 0 .94-.478.858-1.003-.153-.986-.523-1.385-.762-1.643z"
    />
</svg>
